import DeleteIcon from '@mui/icons-material/Delete';
import { Card, CardContent, Grid, IconButton, Tooltip, Typography } from '@mui/material';

import { FormInput } from '../../../components/hook-form/form-input.component';
interface BuildingFloorFormProps {
  name: string;
  index?: number;
  onRemove?: (index: number) => void;
}

export const BuildingFloorForm = ({ name, index, onRemove }: BuildingFloorFormProps) => {
  return (
    <Card elevation={0} className=" noPad">
      <CardContent className="noPad ">
        <Grid container spacing={0}>
          <Grid item lg={12} sm={12} xl={12} xs={12} className="d-flex">
            {/* {index !== undefined && index >= 0 ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>{index + 1}</div>
            ) : null} */}
            <div style={{ padding: '10px' }}>
              <FormInput name={`${name}.floorNo`} label="Floor No." type="number" />
            </div>
            <div style={{ padding: '10px' }}>
              <FormInput name={`${name}.unitsCount`} label="Unit" type="number" />
            </div>
            {onRemove && index !== undefined && index >= 0 && (
              <div style={{ marginLeft: 'auto' }}>
                <IconButton aria-label="delete" onClick={() => onRemove(index)}>
                  <Tooltip title={<Typography variant="body1">Delete</Typography>}>
                    <DeleteIcon className="btnDelete" />
                  </Tooltip>
                </IconButton>
              </div>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
